import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import DatePickerField from 'components/form/datepicker'
import moment from 'moment'
import withFieldError from 'components/form/with-error'

const timezone = () => {
  const result = moment().format('Z')
  return result.substring(0, result.indexOf(':'))
}

export const MentionExperienceNameInput = ({
  input,
  meta: { touched, error }
}) => (
  <input
    {...input}
    id='brt-experience-name'
    className={'form-control ' + (error && touched && 'has-error')}
    placeholder='Experience Name'
  />
)

MentionExperienceNameInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

const ExperienceNameWithError = withFieldError(MentionExperienceNameInput)

const DatePickerFieldWithError = withFieldError(DatePickerField)

export const required = value => (value ? undefined : 'Required')

export const endDateError = (endDate, { startDate }) => {
  // istanbul ignore else
  if (startDate > endDate) {
    return 'End date cannot be before start date'
  }
}

export const endDateWarning = endDate => {
  // istanbul ignore else
  if (endDate < moment.now()) {
    return 'End date is in the past, experience will be saved as expired.'
  }
}

const ConfigureInfo = () => (
  <div className='br-experience-info fluid-container'>
    <div className='form-group row'>
      <label className='col-sm-3 col-md-3 col-lg-2 control-label'>
        Experience Name
      </label>
      <div className='col-sm-9 col-md-9 col-lg-10'>
        <div className='input-icon right'>
          <i className='fa fa-warning tooltips' />
          <Field
            validate={required}
            name='name'
            component={ExperienceNameWithError}
          />
        </div>
      </div>
    </div>
    <div className='form-group row'>
      <label className='col-sm-3 col-md-3 col-lg-2 control-label'>
        Description
        <span className='help-block'>(Optional)</span>
      </label>
      <div className='col-sm-9 col-md-9 col-lg-10'>
        <div className='input-icon right'>
          <i className='fa fa-warning tooltips' />
          <Field
            id='brt-experience-description'
            name='description'
            component='input'
            type='text'
            className='form-control'
            placeholder='A description of the experience'
            autoComplete='off'
          />
        </div>
      </div>
    </div>
    <div className='form-group row'>
      <label className='col-xs-12 col-sm-3 col-lg-2 control-label'>
        Start Date
      </label>
      <div
        id='brt-experience-date-start'
        className='col-xs-9 col-sm-5 col-lg-4'
      >
        <div className='input-icon right'>
          <i className='fa fa-warning tooltips' />
          <Field name='startDate' component={DatePickerField} />
        </div>
      </div>

      <div className='col-xs-3 col-sm-3'>
        <span className='br-timezone'> (GMT {timezone()})</span>
      </div>
    </div>
    <div className='form-group row'>
      <label className='col-xs-12 col-sm-3 col-lg-2 control-label'>
        End Date
      </label>
      <div id='brt-experience-date-end' className='col-xs-9 col-sm-5 col-lg-4'>
        <div className='input-icon right'>
          <i className='fa fa-warning tooltips' />
          <Field
            name='endDate'
            component={DatePickerFieldWithError}
            validate={endDateError}
            warn={endDateWarning}
          />
        </div>
      </div>

      <div className='col-xs-3 col-sm-3'>
        <span className='br-timezone'> (GMT {timezone()})</span>
      </div>
    </div>
  </div>
)

export default ConfigureInfo



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-info/index.js